<template>
    <div v-if="loading" class="page-center">
        <div class="page-center-box text-center">
            <ui-loading-page />
        </div>
    </div>


    <div v-else class="page-inner">

        <div class="page-title">Запрос по страховому случаю</div>

        <div class="hr"></div>

        <div v-if="false" class="position-relative no-list-data">
            <ui-no-data-page text="Список договоров пуст" />
        </div>

        <div v-else>

            <div class="row mt-4">

                <div class="col-md-6 col-lg-6">

                    <ui-input-box-floating :error="errors.typeInsReq">
                        <select v-model="typeInsReq" class="form-control form-select">
                            <option>Запрос на подготовку доверенности на представление интересов в Страховую компанию
                            </option>
                            <option>Запрос на подготовку доверенности на представление интересов в ОВД</option>
                            <option>Запрос на подготовку распорядительного письма в Страховую компанию на выплату страхового
                                возмещения</option>
                        </select>
                        <ui-input-label>Страховой случай</ui-input-label>
                    </ui-input-box-floating>

                    <ui-input-box-floating class="mt-3" :error="errors.typeIns">
                        <select v-model="typeIns" class="form-control form-select">
                            <option>ДТП</option>
                            <option>Пожар</option>
                            <option>Противоправные действия третьих лиц</option>
                            <option>Хищение</option>
                            <option>Иное</option>
                        </select>
                        <ui-input-label>Страховой случай</ui-input-label>
                    </ui-input-box-floating>


                    <div class="mt-4">
                        Обращение в страховую компанию по риску
                    </div>
                    <div class="form-group mt-3">
                        <label>
                            <input type="radio" name="radiogroup" :value="'КАСКО'" v-model="ins"><span>КАСКО</span>
                        </label>
                    </div>
                    <div class="form-group mt-3">
                        <label>
                            <input type="radio" name="radiogroup" :value="'ОСАГО'" v-model="ins"><span>ОСАГО</span>
                        </label>
                    </div>

                    <ui-input-box-floating class="mt-4" :error="errors.number">
                        <ui-input v-model="number" class="form-control" placeholder="Номер выплатного дела" />
                        <ui-input-label>Номер выплатного дела</ui-input-label>
                        <div class="form-text">
                            При обращении по ОСАГО в компанию виновника для подготовки
                            распорядительного письма необходимо указывать номер выплатного дела
                        </div>
                    </ui-input-box-floating>

                    <ui-input-box-floating class="mt-3" :error="errors.type">
                        <select v-model="type" class="form-control form-select">
                            <option :value="null">Не выбран</option>

                            <option v-for="item in pl">{{ item['ТипТС'] }}: {{ item['МаркаТС'] }}: {{ item['ИН'] }}: {{
                                item['РегНомерТС'] }}: {{ item['Номер'] }}</option>
                        </select>
                        <ui-input-label>Предмет договора лизинга</ui-input-label>
                    </ui-input-box-floating>


                    <ui-input-box class="mt-3" :error="errors.message">
                        <ui-textarea v-model="message" placeholder="Примечания" rows="3" />
                    </ui-input-box>

                    <ui-input-box-floating class="mt-3" :error="errors.pass">
                        <ui-input v-maska data-maska="####_######" v-model="pass" class="form-control"
                            placeholder="Паспортные данные заявителя" />
                        <ui-input-label>Паспортные данные заявителя</ui-input-label>
                    </ui-input-box-floating>


                    <div class="row">

                        <div class="col-6">

                            <ui-input-box-floating class="mt-3" :error="errors.name">
                                <ui-input v-model="name" class="form-control" placeholder="Имя" />
                                <ui-input-label>Имя</ui-input-label>
                            </ui-input-box-floating>

                        </div>

                        <div class="col-6">

                            <ui-input-box-floating class="mt-3" :error="errors.phone">
                                <ui-input v-maska data-maska="+7 (###) ###-##-##" v-model="phone" class="form-control"
                                    placeholder="Номер выплатного дела" />
                                <ui-input-label>Телефон</ui-input-label>
                            </ui-input-box-floating>

                        </div>

                    </div>

                    <ui-input-box-floating class="mt-3" :error="errors.email">
                        <ui-input v-model="email" class="form-control" placeholder="Номер выплатного дела" />
                        <ui-input-label>E-mail</ui-input-label>
                    </ui-input-box-floating>


                    <div v-if="error" class="login-alert p-3 text-center mt-3">
                        <div class="text-primary">Внимание!</div>
                        <span>{{ error }}</span>
                    </div>

                    <div v-if="success" class="success-alert p-3 text-center mt-3">
                        <div class="text-primary">Внимание!</div>
                        <span>{{ success }}</span>
                    </div>

                </div>
            </div>

            <ui-button @click="send" class="btn-base mt-3 me-2" :loading="loadingSend"
                :disabled="loadingSend">Отправить</ui-button>


        </div>


    </div>
</template>

<script>
import { getApi, postApi } from '@/run'

import { mapGetters } from "vuex";

export default {
    name: 'request.accounting',
    data() {
        return {
            loading: false,
            loadingSend: false,
            pl: [],
            phone: '+7',
            type: null,
            typeIns: 'ДТП',
            typeInsReq: 'Запрос на подготовку доверенности на представление интересов в Страховую компанию',
            ins: 'КАСКО',
            number: null,
            message: null,
            name: null,
            pass: null,
            email: null,
            error: null,
            errors: [],
            success: null
        }
    },
    components: {},
    created() {
        document.title = "Запрос по страховому случаю - STONE-XXI"
        this.email = this.getEmail
        this.start()
    },
    computed: {
        ...mapGetters({
            getEmail: 'main/getEmail'
        })
    },
    methods: {
        start() {
            this.loading = true

            getApi('/insurance/insurancePl', {}).then(response => {

                if (response.status) {
                    this.pl = response.pl
                }

                this.loading = false
            })
        },
        send() {
            this.loadingSend = true
            this.error = null
            this.success = null

            postApi('/insurance/request', {
                typeIns: this.typeIns,
                typeInsReq: this.typeInsReq,
                ins: this.ins,
                number: this.number,
                type: this.type,
                message: this.message,
                pass: this.pass,
                name: this.name,
                phone: this.phone,
                email: this.email
            }).then(response => {

                if (response.error) {
                    this.error = response.error
                    this.errors = response.errors ? response.errors : []
                }

                if (response.status) {
                    this.success = response.success
                    this.errors = []
                }

                this.loadingSend = false
            })
        }
    }
}
</script>